// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .ajuste_dialogo {\n  text-align: center;\n}\n[dir] .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {\n  padding: -0.25rem 2rem;\n  margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
